module.exports = {
      id: "icon-star-usage",
      viewBox: "0 0 30.754 29.435",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }